import { ReactElement, ReactHTMLElement, ReactNode, RefObject, useContext, useEffect, useId, useRef, useState } from "react";
import enemy from "url:../../assets/isp/Boss - Steaming.png";
import { Slayable } from "../../components/cursor/Slayable";
import ExecProvider from "../../providers/ExecProvider";
import { useNavigate } from "react-router";
import bg1 from "url:../../assets/xamni/bgs/bg1.png";
import bg2 from "url:../../assets/xamni/bgs/bg2.png";
import bg3 from "url:../../assets/xamni/bgs/bg3.png";
import bg4 from "url:../../assets/xamni/bgs/bg4.png";
import bg5 from "url:../../assets/xamni/bgs/bg5.png";
import bg5_b from "url:../../assets/xamni/bgs/bg5stalag.png";
import bg6 from "url:../../assets/xamni/bgs/bg6.png";
import bg6_b from "url:../../assets/xamni/bgs/bg6stalag.png";
import bg7 from "url:../../assets/xamni/bgs/bg7.png";
import reporter from "url:../../assets/wtrok/fm/News Reporter.png";
import fraidycat from "url:../../assets/wtrok/fm/Fraidycat Watching.png";
import sphinx1 from "url:../../assets/xamni/objs/Sphinx Creature 1.png";
import fish_with_legs from "url:../../assets/xamni/objs/Fish with Legs.png";
import house_with_legs from "url:../../assets/xamni/objs/House with Chicken Legs.png";
import king_mirror from "url:../../assets/xamni/objs/King - Mirror.png";
import vulture4 from "url:../../assets/xamni/objs/Vulture 4.png";
import wizard_dejected from "url:../../assets/xamni/objs/Wizard - Dejected.png";
import wizard_happy from "url:../../assets/xamni/objs/Wizard - Happy.png";
import dog_man from "url:../../assets/xamni/objs/Dog-Man.png";
import dwarf_with_sword from "url:../../assets/xamni/objs/Dwarf with Sword.png";
import fox_girl_eating from "url:../../assets/xamni/objs/Fox-Girl Eating .png";
import girl_riding_mouse from "url:../../assets/xamni/objs/Girl Riding Mouse.png";
import lion_beast from "url:../../assets/xamni/objs/Lion Beast.png";
import jester5 from "url:../../assets/xamni/objs/Jester 05.png";
import vulture6 from "url:../../assets/xamni/objs/Vulture 6.png";
import elf_and_frog from "url:../../assets/xamni/objs/Elf & Frog.png"
import elf_zapped from "url:../../assets/xamni/objs/Elf - Zapped.png";
import dwarf1 from "url:../../assets/xamni/objs/Dwarf 1.png";
import sea_creature3 from "url:../../assets/xamni/objs/Sea Creature 3.png";
import dragon_man1 from "url:../../assets/xamni/objs/Dragon Man 1.png";
import actor_rat from "url:../../assets/xamni/objs/Actor - Rat.png";
import boy_elizabethan from "url:../../assets/xamni/objs/Boy - Elizabethan.png";
import flag_bearer2 from "url:../../assets/xamni/objs/Flag-Bearer 2.png";
import nose_flying from "url:../../assets/xamni/objs/Nose Flying.png";
import dwarf2 from "url:../../assets/xamni/objs/Dwarf 2.png";
import giant3 from "url:../../assets/xamni/objs/Giant 3.png";
import bard from "url:../../assets/xamni/objs/Bard.png";
import maiden2 from "url:../../assets/xamni/objs/Maiden 2.png";
import haystack from "url:../../assets/xamni/objs/Haystack.png";
import flag_bearer3 from "url:../../assets/xamni/objs/Flag-Bearer 3.png";
import creature54 from "url:../../assets/xamni/objs/Creature 54.png";
import monster_on_back from "url:../../assets/xamni/objs/Monster on Back.png";
import boy_with_sword2 from "url:../../assets/xamni/objs/Boy with Sword 2.png";
import page3 from "url:../../assets/xamni/objs/Page 3.png";
import two_headed_creature from "url:../../assets/xamni/objs/Two-Headed Creature.png";
import fountain3 from "url:../../assets/xamni/objs/Fountain 3.png";
import druid1 from "url:../../assets/xamni/objs/Druid 1.png";
import magician_and_wand from "url:../../assets/xamni/objs/Magician & Wand.png";
import actor4 from "url:../../assets/xamni/objs/Actor 04.png";
import barrel2 from "url:../../assets/xamni/objs/Barrel 2.png";
import boy_with_apple from "url:../../assets/xamni/objs/Boy with Apple.png";
import actress2 from "url:../../assets/xamni/objs/Actress 2.png";
import castle30 from "url:../../assets/xamni/objs/Castle 30.png";
import flag_bearer1 from "url:../../assets/xamni/objs/Flag-Bearer 1.png";
import house_magic from "url:../../assets/xamni/objs/House - Magic.png";
import sixteenth_century_woman2 from "url:../../assets/xamni/objs/16th Century Woman 2.png";
import wizard_evil1 from "url:../../assets/xamni/objs/Wizard - Evil 1.png";
import stone_pond from "url:../../assets/xamni/objs/Stone Pond.png";
import castle47 from "url:../../assets/xamni/objs/Castle 47.png";
import gargoyle3 from "url:../../assets/xamni/objs/Gargoyle 03.png";
import creature_baby from "url:../../assets/xamni/objs/Creature - Baby.png";
import creature29 from "url:../../assets/xamni/objs/Creature 29.png";
import creature46 from "url:../../assets/xamni/objs/Creature 46.png";
import creature22 from "url:../../assets/xamni/objs/Creature 22.png";
import creature25 from "url:../../assets/xamni/objs/Creature 25.png";
import creature26 from "url:../../assets/xamni/objs/Creature 26.png";
import creature36 from "url:../../assets/xamni/objs/Creature 36.png";
import creature23 from "url:../../assets/xamni/objs/Creature 23.png";
import woman_bird1 from "url:../../assets/xamni/objs/Woman-Bird 1.png";
import castle25 from "url:../../assets/xamni/objs/Castle 25.png";
import castle35 from "url:../../assets/xamni/objs/Castle 35.png";
import creature43 from "url:../../assets/xamni/objs/Creature 43.png";
import beast_in_hole from "url:../../assets/xamni/objs/Beast in Hole.png";
import creature24 from "url:../../assets/xamni/objs/Creature 24.png";
import cart from "url:../../assets/xamni/objs/Cart.png";
import castle22 from "url:../../assets/xamni/objs/Castle 22.png";
import man_dog from "url:../../assets/xamni/objs/Man-Dog.png";
import creature49 from "url:../../assets/xamni/objs/Creature 49.png";
import creature33 from "url:../../assets/xamni/objs/Creature 33.png";
import creature34 from "url:../../assets/xamni/objs/Creature 34.png";
import creature32 from "url:../../assets/xamni/objs/Creature 32.png";
import { CursorComponent } from "../../components/cursor/CursorComponent";
import { CursorState } from "../../providers/CursorProvider";
import { Plzma } from "../../components/cursor/plz/Plzma";
import { Smashable } from "../../components/cursor/Smashable";
import { Smashchange } from "../../components/cursor/Smashchange";
import { FreeDrag } from "../../components/cursor/draggables/FreeDrag";
import { Plzen } from "../../components/cursor/plz/Plzen";
import { SlotDrag } from "../../components/cursor/draggables/SlotDrag";
import { Stated } from "../../components/Stated";
import { Img100 } from "../../components/Img100";
import { XANMIT } from "./XANMIT";
import { BONGO } from "../TACO/TACOG";

const CMD_FIN = 'xanmi-fin';

export function XANMI () {
    const exec = useContext(ExecProvider.context);
    const nav = useNavigate();

    return <div className="page-basic width-100v bg-black">
        <div className="v-box pos-rel width-768 mask-content">
            <div className="v-box pos-rel width-100p">
                <img src={bg1} className="width-100p" />
                <Talker
                    src={nose_flying}
                    x={80} y={1} w={10}
                    texts={[
                        "Smells like trouble..."
                    ]} position={DialoguePosition.Left}>
                </Talker>
                <BoringThing src={castle35} x={2} y={11} w={36} />
                <BoringThing src={fountain3} x={60} y={15} w={9} />
                <Talker
                    src={flag_bearer1}
                    x={28} y={15} w={5}
                    texts={[
                        "Halt! No Bugs allowed!",
                        "Oh, wait... you're not a Bug.", 
                        "Proceed at your own pearil.",
                        "Peril, sorry. I meant peril."
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Right} 
                />
                <Talker
                    src={flag_bearer3}
                    x={2} y={15} w={7}
                    texts={[
                        "Have you seen the Lord?",
                        "Tall orange hat?",
                        "Oh, well."
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Right}
                />
                <BoringThing src={castle30} x={78} y={13.5} w={20} />
                <Talker
                    src={flag_bearer2}
                    x={76} y={19} w={8}
                    texts={[
                        "I just hold the flag, buddy.",
                        "Move along.",
                        "Don't get eaten by a bug.",
                        "Or do get eaten by a bug. Whatever.",
                        "I just hold the flag, like I said."
                    ]} position={DialoguePosition.Left}
                />
                <Talker x={10} y={20} w={10}
                    src={reporter}
                    texts={[
                        "This just in...",
                        "You've been isekai'ed!",
                        "Back to you, Janet."
                    ]} position={DialoguePosition.Right}
                    ps={[
                        new PostScript(2, "I'm off the air now."),
                        new PostScript(3, "Stop clicking on me."),
                        new PostScript(4, "Scroll down! Get away from me!"),
                        new PostScript(5, "This isn't funny!"),
                        new PostScript(7, "Okay, it's a *little* bit funny."),
                        new PostScript(8, "But not anymore. Stop it."),
                        new PostScript(99, "Okay it's funny again lol."),
                        new PostScript(103, "Am I alive?"),
                        new PostScript(104, "I'm a soulless webstie element, aren't I?")
                    ]}
                />
                <Talker
                    src={bard}
                    x={63} y={23} w={6}
                    bubbleWidth={256}
                    texts={[
                        "Oh, noble traveller, over there",
                        "Oh, noble traveller, over there\nWith kindest eyes and flowing hair",
                        "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair",
                        "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair\nDestroyin' homes, its quite a scare",
                        "Oh, noble traveller, over there\nWith kindest eyes and flowing hair\nI said to them, these bugs aren't fair\nDestroyin' homes, its quite a scare\nThe devil bugs, they're everywhere!",
                        "Help defeat the bugs of ten",
                        "Help defeat the bugs of ten\nThen follow Smog unto its den",
                        "Help defeat the bugs of ten\nThen follow Smog unto its den\nCage the beast that threatens thee",
                        "Help defeat the bugs of ten\nThen follow Smog unto its den\nCage the beast that threatens thee\nOr at least that threatens me!!",
                        "A bard is good, I do my best",
                        "A bard is good, I do my best\nI sing the songs of big conquest",
                        "A bard is good, I do my best\nI sing the songs of big conquest\nI do not fight, I flee again",
                        "A bard is good, I do my best\nI sing the songs of big conquest\nI do not fight, I flee again\nRetreat to stories from my pen",
                        "...",
                        "Tis the only song I've got, sorry."
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={sphinx1}
                    x={4} y={30} w={30}
                    texts={[
                        "...",
                        "Your ame is strange."
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={druid1}
                    x={42} y={45} w={6}
                    texts={[
                        "Bugs... are merely a state of mind."
                    ]} position={DialoguePosition.Left}
                />
                <Bug
                    src={creature22}
                    x={70} y={38} w={14}
                    texts={[
                        "*enthusiastic gurgling*"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={king_mirror}
                    x={82} y={42} w={14}
                    texts={[
                        "A bug trapped me in this mirror.",
                        "Destroy them, noble traveler."
                    ]} position={DialoguePosition.Left}
                />
                <BarrelCat />
                <Bug
                    src={creature26}
                    x={0} y={58} w={25}
                    texts={[
                        "Bug strong.. Can eat boy. Easy lunch",
                        "Mm... lunch"
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={boy_with_sword2}
                    x={64} y={64} w={6}
                    texts={[
                        "Uh oh...",
                        "Oh no!",
                        "Ohhh NO!",
                        "I'm gonna get ate!!!"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Talker
                    src={creature_baby}
                    bubbleWidth={64}
                    x={16} y={74} w={6}
                    texts={[ "Brrp.."]}
                    end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Talker
                    src={monster_on_back}
                    x={24} y={73} w={13}
                    texts={[
                        "*huff huff huff*... He almost died!",
                        "That Bug knocked this baby thing into the river!",
                        "This place sucks!"
                    ]} position={DialoguePosition.Right}
                />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg2} className="width-100p" />
                <Talker
                    src={giant3}
                    x={54} y={-10} w={45}
                    texts={[
                        "New hat says to crush you.",
                        "Hats never lie.",
                        "Right and good hat, full of smarts."
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Bug
                    src={creature32}
                    x={69} y={-12} w={24}
                    texts={[
                        "TALL",
                        "I AM HAT",
                        "BUG HAT"
                    ]} position={DialoguePosition.Left}
                />
                <SmashableThing src={cart} x={10} y={15} w={24} />
                <SmashableThing src={barrel2} x={33} y={17} w={5} />
                <SmashableThing src={barrel2} x={46} y={38} w={5} />
                <SmashableThing src={barrel2} x={43} y={39} w={5} />
                <Talker
                    src={house_magic}
                    x={58} y={30} w={40}
                    texts={[
                        "My mouth is a door.",
                        "It hurts",
                        "To be this"
                    ]} position={DialoguePosition.Left}
                />
                <Bug
                    src={creature24}
                    x={64} y={27} w={15}
                    texts={[
                        "Stand on house, tall now.",
                        "Big, like Smog"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={jester5}
                    x={5} y={43} w={10}
                    texts={[
                        "I thrive in chaos!"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Right}
                />
                <Talker
                    src={wizard_evil1}
                    x={90} y={40} w={8}
                    texts={[
                        "I hate dads.",
                        "Dads are bads.",
                        "You're not a dad, are you?"
                    ]} position={DialoguePosition.Left}
                />
                <Bug 
                    src={creature33} 
                    x={65} y={43} w={18}
                    texts={[
                        "Blurp",
                        "Grubble"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={house_with_legs}
                    x={28} y={43} w={33}
                    texts={[
                        "*menacing stance*"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Right}
                />
                <Talker
                    src={boy_elizabethan}
                    x={90} y={46} w={8}
                    texts={[
                        "Me dad...'E got turned into a dog man 'e did.",
                        "That mean magic man did it to 'im",
                        "Now 'e just cries and woofs",
                        "Ran away from home... where's me da..." 
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Talker
                    src={fish_with_legs}
                    x={70} y={48} w={9}
                    texts={[
                        "I'm a real guy outta land hoohoo heehee",
                        "Get it?"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={lion_beast}
                    x={5} y={54} w={35}
                    texts={[
                        "WHEEREEEe is my BEAUUTIFFFULL WIIIFEEEE ??",
                        "WE HAVE DINNER PLANS",
                        "SHE'S SO BEAUTIFUL...",
                        "WIFE???"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Right}
                />
                <Talker
                    src={sixteenth_century_woman2}
                    x={62} y={56} w={8}
                    texts={[
                        "Can you please destroy those bugs?",
                        "They're displacing the mirth."
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={elf_and_frog}
                    x={85} y={56} w={8}
                    texts={[
                        "WEEEEEEEEEE",
                        "WWEEEEEEEEEEE"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Talker
                    src={maiden2}
                    x={45} y={65} w={12}
                    texts={[
                        "You should smile more, old man"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={wizard_dejected}
                    x={60} y={64.5} w={11}
                    bubbleWidth={64}
                    texts={[
                        "I'm 26..."
                    ]} position={DialoguePosition.Right}
                />
                <Bug
                    src={creature22}
                    x={17} y={72} w={20}
                    texts={[
                        "I'M GOONA EAT SOMETHING",
                        "NEED TO EAT SOON",
                        "I'M GOONA EAT ONE THESE PEOPLE",
                        "NOT EVEN GONNA CHEW"
                    ]} position={DialoguePosition.Below}
                />
                <SmashableThing src={barrel2} x={80} y={77} w={5} />
                <SmashableThing src={barrel2} x={83} y={78} w={5} />
                <SmashableThing src={barrel2} x={14} y={83} w={10} loot={
                    <Talker
                        src={actor_rat}
                        x={0} y={0} w={100}
                        texts={[
                            "Finally!",
                            "I've been freed from foul barrel!",
                            "Oh blessed day of unbarrelled splendor!",
                            "Fortune upon you, strange hero!",
                            "You have rescued an artist from darkness!",
                            "Light shines upon the Rat Poet once again!"
                        ]} position={DialoguePosition.Right} end={EndBehavior.Loop}
                    />}
                />
                <Talker
                    src={actress2}
                    x={35} y={92} w={14}
                    texts={[
                        "My husband! He's run away again!"
                    ]} position={DialoguePosition.Right}
                />
                <SmashableThing src={barrel2} x={30} y={98} w={5} />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg3} className="width-100p" />
                <SmashableThing src={barrel2} x={80} y={7} w={8} loot={<BONGO height={96} />} />
                <BoringThing src={stone_pond} x={2} y={-2.5} w={30} />
                <Talker
                    src={dwarf2}
                    x={28} y={20} w={13}
                    texts={[
                        "I use my ame! My lifeforce! To make beatiful art!!"
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={dwarf1}
                    x={20} y={22.5} w={7}
                    texts={[
                        "My life is my art."
                    ]} position={DialoguePosition.Right}
                />
                <Bug
                    src={creature25}
                    x={45} y={25} w={25}
                    texts={[
                        "Da great smog fuels me. Yumma yumma",
                        "I said YUMMA YUMMA"
                    ]} position={DialoguePosition.Left}
                />
                <BoringThing src={castle25} x={40} y={55} w={35} />
                <PoweredThing
                    src={gargoyle3}
                    x={67} y={68} w={14}
                    texts={[
                        "AWAKE!",
                        "STONE...",
                        "YES, STONE!!",
                        "THE ANSWER LIES IN STONE!!"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={girl_riding_mouse}
                    x={15} y={72} w={18}
                    texts={[
                        "Be careful of the beasts ahead! It's not safe here!"
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={creature54}
                    x={70} y={85} w={23}
                    texts={[
                        "*burp* Do you come to the Valley of NAN often?"
                    ]} position={DialoguePosition.Left}
                />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg4} className="width-100p" />
                <Bug
                    src={creature34}
                    x={-25} y={-6} w={65}
                    texts={[
                        "Wut are u? Bug like me?"
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={dog_man}
                    x={56} y={39} w={20}
                    texts={[
                        "Boo hoo bark woof boo hoo hoo",
                        "Woof woof boo hoo"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
                <Talker
                    src={beast_in_hole}
                    x={78} y={50} w={8}
                    texts={[
                        "This neighborhood's really gone to the dogs."
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={dwarf_with_sword}
                    x={33} y={59} w={12}
                    texts={[
                        "Be still foul beast!! The surface is not for you!"
                    ]} position={DialoguePosition.Right}
                />
                <Bug
                    src={creature46}
                    x={8} y={62} w={25}
                    texts={[
                        "Wommmp woooahhmmpp!!"
                    ]} position={DialoguePosition.Right}
                />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg5} className="width-100p" />
                <Talker
                    src={dragon_man1}
                    x={82} y={2} w={15}
                    texts={[
                        "No bugs getting past me, no way",
                        "Oh, bugs did get past me?",
                        "Oops"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={two_headed_creature}
                    x={2} y={40} w={20}
                    texts={[
                        "Do you have apple?",
                        "Yes, apple, please?"
                    ]} position={DialoguePosition.Right}
                />
                <Talker
                    src={vulture6}
                    x={49} y={45} w={49}
                    texts={[
                        "The smog lies below.",
                        "I cannot contain him."
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={woman_bird1}
                    x={8} y={68} w={8}
                    texts={[
                        "It's quiet down here...",
                        "Please don't tell me husband where you found me."
                    ]} position={DialoguePosition.Right}
                />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg6} className="width-100p" />
                <Bug
                    src={creature43}
                    x={50} y={-2} w={24}
                    texts={[
                        "Wish i had apple..."
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={page3}
                    x={12} y={20} w={7}
                    rotation={200}
                    texts={[
                        "Glad I brought my apple!"
                    ]} position={DialoguePosition.Right}
                />
            </div>
            <div className="v-box pos-rel width-100p">
                <img src={bg7} className="width-100p" />
                <Bug
                    src={creature29}
                    x={57} y={35} w={25}
                    texts={[
                        "ZEEP ZOOPIN UR BUNZ!!"
                    ]} position={DialoguePosition.Left}
                />
                <Talker
                    src={elf_zapped}
                    x={38} y={42} w={18}
                    texts={[
                        "YEOUCH! MY BUNS!!",
                        "OWW OW OWWW OW",
                        "MY BUNS!!"
                    ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                />
            </div>
            <XANMIT />
        </div>
    </div>
}

export enum DialoguePosition
{
    Left,
    Right,
    Above,
    Below
}

export enum EndBehavior
{
    End,
    Loop
}

class PostScript
{
    i: number = 0;
    text: string = "";

    constructor(i : number, text: string)
    {
        this.i = i;
        this.text = text;
    }
}

export function Talker (props: { 
    x: number,
    y: number,
    w: number,
    texts: string[],
    position: DialoguePosition,
    bubbleWidth ?: number,
    bubbleClass ?: string,
    end ?: EndBehavior,
    onEnded ?: () => void,
    src ?: string,
    className ?: string,
    children ?: ReactNode,
    rotation ?: number,
    flipH ?: boolean,
    ps ?: PostScript[],
    id ?: string,
    autotalk ?: boolean,
    autotalkLineTime ?: number
}) {
    const [dialogue, setDialogue] = useState("");
    let clicks = 0;
    const anim = useRef('');

    const endBehaviour = props.end !== undefined ? props.end : EndBehavior.Loop;
    const id = props.id !== undefined ? props.id : useId();
    
    let animationFrame: number;
    const autotalk = props.autotalk !== undefined ? props.autotalk : false;
    const autotalkLineTime = props.autotalkLineTime !== undefined ? props.autotalkLineTime : 2;
    let lastTalkTime = 0;

    const resetTalkTime = () => { lastTalkTime = Date.now() / 1000.0; };
    resetTalkTime();

    const onClick = () => {
        advanceTalkState();
    }

    const autoUpdate = () => {
        const currentTimeInSeconds = Date.now() / 1000.0;
        if (currentTimeInSeconds - lastTalkTime > autotalkLineTime)
            advanceTalkState();
    }

    const advanceTalkState = () => {
        resetTalkTime();

        clicks ++;
        const index = Math.floor(clicks / 2);
        const count = props.texts.length;
        if (clicks % 2 == 0)
        {
            setDialogue("");
            anim.current = "";
            if (index == count && props.onEnded !== undefined)
                props.onEnded();
            return;
        }

        anim.current = "wiggle-1s";

        if (index < count)
        {
            setDialogue(props.texts[index]);
            return;
        }

        const overflow = index - count;
        if (props.ps !== undefined)
        {
            for (let i = 0; i < props.ps.length; i++)
            {
                if (props.ps[i].i == overflow)
                {
                    setDialogue(props.ps[i].text);
                    return;
                }
            }           
        }

        if (endBehaviour == EndBehavior.Loop)
        {
            setDialogue(props.texts[index % count]);
            return;
        }

        setDialogue("...");
    }

    const init = () => {
        if (autotalk)
            loop();
    }

    const deinit = () => {
        if (autotalk)
            cancelAnimationFrame(animationFrame);
    }

    const loop = () => {
        autoUpdate();
        animationFrame = requestAnimationFrame(loop);
    };

    useEffect(() => {
        init();
        return () => {
            deinit();
        }
    }, [props]);

    const width = props.bubbleWidth !== undefined ? props.bubbleWidth : 192;
    const halfWidth = width / 2.0;

    let style;
    switch (props.position)
    {
        case DialoguePosition.Left:
            style = { top: "20%", left: "calc(-" + (width + 16) + "px - 10%)", width };
            break;
        case DialoguePosition.Right:
            style = { top: "20%", right: "calc(-" + (width + 16) + "px - 10%)", width };
            break;
        case DialoguePosition.Above:
            style = { top: "-30%", left: "calc(50% - " + halfWidth + "px)", width };
            break;
        case DialoguePosition.Below:
            style = { bottom: "-20%", left: "calc(50% - " + halfWidth + "px)", width };
            break;
    }

    const flipH = props.flipH !== undefined ? -1 : 1;
    const rotation = props.rotation !== undefined ? props.rotation : 0;
    const img = props.src !== undefined 
        ? <img 
            src={props.src}
            className="width-100p"
            style={{
                transform: "rotateZ(" + rotation + "deg) scaleX(" + flipH + ")"
            }}  
        /> : props.children;

    const className = props.className !== undefined ? props.className : '';
    const bubbleClass = props.bubbleClass !== undefined
                    ? props.bubbleClass
                    : "bg-white-off border-black padding-8 border-radius-4";

    return <CursorComponent
        id={id}
        cursor={CursorState.STD}
        onClick={onClick}
        className={"pos-abs " + className}
        style={{
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%",
        }}>
        <div className={anim.current}>{ img }</div>
        {
            dialogue == "" ? null
            : <div className={"pos-abs z-10 " + bubbleClass}  style={style}>
                { dialogue.split('\n').map((d, i) => <div key={"d" + i}>{ d }</div>) }
            </div>
        }
    </CursorComponent>
}

function PoweredThing (props: {
    src: string,
    x: number,
    y: number,
    w: number,
    texts: string[],
    position: DialoguePosition
}) {
    return <Plzma
        onState={
            <Talker
                src={props.src}
                x={0} y={0} w={100}
                className="pulse-3s"
                texts={props.texts} position={props.position} end={EndBehavior.Loop}
            />
        }
        offState={
            <Img100 src={props.src} className="bug-off" />
        }
        className="pos-abs"
        style={{
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        }}
        startOn={false}
    />
}

function SmashableThing (props: {
    src: string,
    x: number,
    y: number,
    w: number,
    stateRef ?: RefObject<boolean>,
    onSmash ?: () => void,
    loot?: ReactNode
}) {
    return <Smashable
        className="pos-abs"
        style={{
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        }}
        loot={props.loot}
        stateRef={props.stateRef}
        onSmash={props.onSmash}>
        <Img100 src={props.src} />
    </Smashable>
}

function BoringThing(props: {
    src: string,
    x: number,
    y: number,
    w: number
}) {
    return <div className="pos-abs" style={{
        top: props.y.toString() + "%",
        left: props.x.toString() + "%",
        width: props.w.toString() + "%"
    }}>
        <Img100 src={props.src} />
    </div>;
}

function Bug(props: {
    src: string,
    x: number,
    y: number,
    w: number,
    texts: string[]
    position: DialoguePosition
}) {
    const delay : number = Math.random();
    return <Plzma
        className="pos-abs"
        style={{
            top: props.y.toString() + "%",
            left: props.x.toString() + "%",
            width: props.w.toString() + "%"
        }} 
        onState={ 
            <Talker
                x={0} y={0} w={100}
                texts={props.texts} 
                position={props.position}
                bubbleClass="bug-bubble bug-on">
                <Img100 src={props.src} className="bug-on" />
            </Talker>
        }
        offState={ <Img100 src={props.src} className="bug-off" /> }
        startOn={true}
    />
}

function BarrelCat () {
    const [check, setCheck] = useState(0);
    const barrelRef = useRef(false);
    
    const checkAgain = () => {
        setCheck(check + 1);
    };

    return <div className="pos-abs" style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }}>
        <Stated
            check={check}
            states={[
                {
                    index: 1,
                    node: <Talker
                        src={fraidycat}
                        x={82} y={54} w={8}
                        texts={[
                            "Meow!",
                            "Myew...",
                            "Mrrraw!",
                            "MEOW"
                        ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                    />,
                    check: () => { return !barrelRef.current; },
                    canReturnTo: true
                },
                {
                    index: 2,
                    node: <Talker
                        src={fraidycat}
                        x={84} y={54} w={8}
                        texts={[
                            "Oh thank god.",
                            "That was an evil barrel."
                        ]} end={EndBehavior.Loop} position={DialoguePosition.Left}
                    />,
                    check: () => { 
                        return barrelRef.current;
                    }
                }
            ]}
        />
        <SmashableThing src={barrel2} x={46} y={58} w={5} stateRef={barrelRef} onSmash={checkAgain} />
    </div>
}